
export default {
	methods: {
		async storeDeviceReport(key, payload) {
			await this.updateIndexedDB(payload, 'store')
			await this.storeDeviceReportRequest(key, payload)
		},
		async deleteDeviceReport(key, payload) {
			await this.updateIndexedDB(payload, 'delete')
			await this.storeDeviceReportRequest(key, payload)
		},
		async updateIndexedDB(payload, type) {
			const devices = await this.fetchDataFromIndexedDB(`pwa/intervention/${payload.intervention_id}/devices`)
			const site = await this.fetchDataFromIndexedDB(`pwa/intervention/${payload.intervention_id}/site`)
			
			let devicesDataInStore = devices.value
			let siteDataInStore = site.value
			
			/*** Store Device Report ***/
			if(type === 'store') {
				/*** Update intervention devices ***/
				if(payload.is_same_intervention_type) {
					devicesDataInStore.checked.sameInterventionType.push(payload.device_id)
					devicesDataInStore.notChecked.sameInterventionType = devicesDataInStore.notChecked.sameInterventionType.filter(deviceId => {
						return deviceId !== payload.device_id
					})
				} else {
					devicesDataInStore.checked.notSameInterventionType.push(payload.device_id)
					devicesDataInStore.notChecked.notSameInterventionType = devicesDataInStore.notChecked.notSameInterventionType.filter(deviceId => {
						return deviceId !== payload.device_id
					})
				}
				
				/*** Update devices in the site ***/
				siteDataInStore.devices.map(device => {
					if(device.id === payload.device_id) {
						device.reports.push({ id: parseInt(payload.device_report_type_id + '' + payload.device_id) })
					}
				})
			}
			
			/*** Remove Device Report ***/
			else if(type === 'delete') {
				/*** Update intervention devices ***/
				if(payload.is_same_intervention_type) {
					devicesDataInStore.checked.sameInterventionType = devicesDataInStore.checked.sameInterventionType.filter(deviceId => {
						return deviceId !== payload.device_id
					})
					devicesDataInStore.notChecked.sameInterventionType.push(payload.device_id)
				} else {
					devicesDataInStore.checked.notSameInterventionType = devicesDataInStore.checked.notSameInterventionType.filter(deviceId => {
						return deviceId !== payload.device_id
					})
					devicesDataInStore.notChecked.notSameInterventionType.push(payload.device_id)
				}
				
				/*** Update devices in the site ***/
				siteDataInStore.devices.map(device => {
					if(device.id === payload.device_id) {
						device.reports = []
					}
				})
			}
			
			/***  Update data in IndexedDB ***/
			const db = await this.getIndexedDBConnection()
			const tx = db.transaction('data', 'readwrite')
			const store = tx.objectStore('data')
			store.put({ key: 'pwa/intervention/' + payload.intervention_id + '/devices', value: devicesDataInStore })
			store.put({ key: 'pwa/intervention/' + payload.intervention_id + '/site', value: siteDataInStore })
			return tx.complete
		},
		async storeDeviceReportRequest(key, payload) {
			if(key.includes('/delete')) {
				await this.getRequestsInIndexedDB('requests').then(async (requests) => {
					const sendDeviceReportRequest = requests.find(request =>
						request.key.includes('device') &&
						request.key.includes('report') &&
						!request.key.includes('delete') &&
						request.key.includes(payload.device_id)
					)
					
					if(sendDeviceReportRequest) {
						await this.deleteRequestInIndexedDB(`pwa/device/${payload.device_id}/${payload.intervention_id}/report`)
					} else {
						await this.storeRequest(key, payload)
					}
				})
			} else {
				await this.storeRequest(key, payload)
			}
		},
	}
}
